module.exports = __webpack_public_path__ + "static/media/logo-1.ceff4fa5.svg";